export const regionConfig = process.env.__REGION_CONFIG__;
export function getRegionConfig() {
  return regionConfig;
}
